import React, { useContext } from 'react';
import { GENERATIONS } from './helper';
import AppContext from './AppContext';
import { Checkbox } from './components/Checkbox';
import { Button } from './components/Button';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './components/Accordion';

const getNumberOfAllowedGenerations = (gensAllowed: { [key: string]: boolean }) => (
  Object.keys(gensAllowed)
    .map((gen: string): number => {
      if (gensAllowed[gen]) return 1;
      return 0;
    })
    .reduce((partialSum, currentValue) => partialSum + currentValue, 0)
);

function PokedexFiltersGenerations() {
  const {
    gensAllowed,
    handleSetGensAllowed,
    handleSetAllGenerations,
  } = useContext(AppContext);

  // Hacky to make two columns work
  const firstHalfCheckboxes: JSX.Element[] = [];
  const secondHalfCheckboxes: JSX.Element[] = [];
  GENERATIONS.forEach((gen, index) => {
    const checkbox = (
      <div key={`${gen}-gen-checkbox`} className="items-top flex space-x-2 my-1">
        <Checkbox
          checked={gensAllowed[gen.value]}
          name={gen.name}
          value={gen.value}
          onCheckedChange={() => handleSetGensAllowed(gen.value)}
        />
        <label
          key={`${gen.value}-checkbox`}
          htmlFor="gen-checkbox"
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          {gen.name}
        </label>
      </div>
    );
    if (index < 5) firstHalfCheckboxes.push(checkbox);
    else secondHalfCheckboxes.push(checkbox);
  });

  const shouldSetAll = getNumberOfAllowedGenerations(gensAllowed) === 0;

  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="generation-filter">
        <AccordionTrigger>Generation Filter</AccordionTrigger>
        <AccordionContent>
          <div className="grid grid-cols-2">
            {firstHalfCheckboxes}
            {secondHalfCheckboxes}
          </div>
          <div className="my-1 flex items-center justify-center">
            <Button
              onClick={() => handleSetAllGenerations(shouldSetAll)}
              variant="ghost"
            >
              {shouldSetAll ? 'Select All' : 'Deselect All'}
            </Button>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export default PokedexFiltersGenerations;
